import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const DeleteComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__delete"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M1.75 3.5H2.91667H12.25"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0833 3.49984V11.6665C11.0833 11.9759 10.9604 12.2727 10.7416 12.4915C10.5228 12.7103 10.226 12.8332 9.91663 12.8332H4.08329C3.77387 12.8332 3.47713 12.7103 3.25833 12.4915C3.03954 12.2727 2.91663 11.9759 2.91663 11.6665V3.49984M4.66663 3.49984V2.33317C4.66663 2.02375 4.78954 1.72701 5.00833 1.50821C5.22713 1.28942 5.52387 1.1665 5.83329 1.1665H8.16663C8.47605 1.1665 8.77279 1.28942 8.99158 1.50821C9.21038 1.72701 9.33329 2.02375 9.33329 2.33317V3.49984"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83337 6.4165V9.9165"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16663 6.4165V9.9165"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Delete = withIcon(DeleteComponent);
